"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allSizes = exports.propTypeForSizes = exports.toLonghandSize = exports.toShorthandSize = exports.fromProp = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var tshirtLonghandMap = {
  xs: 'extra-small',
  sm: 'small',
  md: 'medium',
  lg: 'large',
  xl: 'extra-large'
};
var tshirtShorthandMap = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};
/**
 * @param  {string} size
 * @returns {{long: string, short: string}} TShirtSize
 */

var fromProp = function fromProp(size) {
  var long = '';
  var short = '';

  if (tshirtLonghandMap[size]) {
    short = size;
    long = tshirtLonghandMap[size];
  } else if (tshirtShorthandMap[size]) {
    short = tshirtShorthandMap[size];
    long = size;
  } else if (typeof size === 'string') {
    long = short = size;
  }

  return {
    short: short,
    long: long
  };
};
/**
 * @param {string} size
 * @returns {string} The shorthand size corresponding to the given longhand size, or `size` itself.
 */


exports.fromProp = fromProp;

var toShorthandSize = function toShorthandSize(size) {
  return tshirtShorthandMap[size] || size;
};
/**
 * @param {string} size
 * @returns {string} The longhand size corresponding to the given shorthand size, or `size` itself.
 */


exports.toShorthandSize = toShorthandSize;

var toLonghandSize = function toLonghandSize(size) {
  return tshirtLonghandMap[size] || size;
};

exports.toLonghandSize = toLonghandSize;
var shortNames = Object.keys(tshirtLonghandMap);
/**
 * @param  [] supportedSizes
 * @param  [] extras - add custom size names here and maybe we'll let it slide
 * @default ['xs', 'sm', 'md', 'lg', 'xl']
 */

var propTypeForSizes = function propTypeForSizes() {
  var supportedSizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shortNames;
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!Array.isArray(supportedSizes)) {
    throw new Error("expected sizes array, got " + supportedSizes);
  }

  if (!supportedSizes.length || !supportedSizes.every(function (size) {
    return tshirtLonghandMap.hasOwnProperty(size);
  })) {
    throw new Error("expected sizes array to include only valid sizes from [xs, sm, md, lg, xl], got [" + supportedSizes.join(', ') + "]");
  }

  var mostValues = [].concat((0, _toConsumableArray2.default)(supportedSizes), (0, _toConsumableArray2.default)(supportedSizes.map(function (k) {
    return tshirtLonghandMap[k];
  })));
  var allValues = [].concat((0, _toConsumableArray2.default)(mostValues), (0, _toConsumableArray2.default)(extras));

  var validator = function validator(props, propName, componentName) {
    if (props[propName]) {
      var value = props[propName];

      if (allValues.indexOf(value) === -1) {
        return new Error(componentName + ": Invalid " + propName + " value. Expected T-Shirt Size (" + mostValues.join(', ') + "), got \"" + value + "\".");
      }
    }

    return null;
  };

  return (0, _createChainablePropType.default)(validator, 'tshirtSize', {
    sizes: supportedSizes,
    aliases: tshirtLonghandMap
  });
};

exports.propTypeForSizes = propTypeForSizes;
var allSizes = propTypeForSizes();
exports.allSizes = allSizes;